import { FlexBox, Icon, Text } from '@dixa/lib-shared-habla';

import markdownToHTML from 'app/utils/markdownToHTML';
import { SafeInnerHtmlSetter } from 'components/shared/util/SafeInnerHtmlSetter';

import messageStyles from '../../../../conversation/components/message/message.module.scss';
import logEntryStyles from '../logEntry/logEntry.module.scss';

import styles from './messageEntryRow.module.scss';

type MessageEntryRowProps = {
  role: string;
  content: string;
};

const roleLabel = (role: string): string =>
  role.toLowerCase() === 'assistant' ? 'Response' : role;

export const MessageEntryRow = ({
  role,
  content,
}: MessageEntryRowProps): JSX.Element => {
  return (
    <FlexBox flexDirection="column" gap="100" width="100%">
      <FlexBox flexDirection="row" alignItems="center" gap="200">
        <div className={logEntryStyles.iconContainer}>
          <Icon name="user" size={16} />
        </div>
        <Text.Paragraph variant="4" subdued>
          {roleLabel(role)}
        </Text.Paragraph>
      </FlexBox>
      <div className={styles.contentBox}>
        <SafeInnerHtmlSetter
          element="div"
          content={markdownToHTML(content)}
          className={messageStyles.text}
          dir="auto"
        />
      </div>
    </FlexBox>
  );
};
